<div [class.impaired]="isImpaired" class="container">
  <div [class.impaired]="isImpaired" class="title-container">
    <span [ngClass]="{ 'button2-impaired-text-dark ml24': isImpaired, 'title-container-title': !isImpaired }">
      {{ 'OTHER.APPEALS_REGISTERED' | translate }}!
    </span>
    <button *ngIf="!isImpaired" class="btn-empty" (click)="close()">
      <svg [icon]="icons.Close" class="svg24 dark-gray-color" />
    </button>

    <app-impaired-icon *ngIf="isImpaired" (clickOnIcon)="close()" [iconName]="icons.Close" [classSize]="'big-impaired'"></app-impaired-icon>
  </div>

  <div [class.impaired]="isImpaired" class="body">
    <div>
      <span [ngClass]="{ 'body1-impaired': isImpaired }">{{ 'OTHER.THANKS' | translate }}! {{ title | translate }}</span>
      <span [ngClass]="{ 'h3-impaired': isImpaired, 'body-title': !isImpaired }"> № {{appealId}}</span>
      <span [ngClass]="{ 'body1-impaired': isImpaired }"> {{ 'OTHER.REGISTERED' | translate }}.</span>
    </div>
  </div>

  <div [class.impaired]="isImpaired" class="footer">
    <button *ngIf="!isImpaired" class="btn-secondary medium" (click)="close()">
      <span class="text">{{ 'OTHER.OK' | translate }}</span>
    </button>
    <button *ngIf="isImpaired" class="button2-impaired" (click)="close()">
      {{ 'OTHER.OK' | translate }}
    </button>
  </div>
</div>
